import React from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { RelatonShipOptions } from "../../../../../../../assets/data/projectData";

const AddDependent = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        isEmployee: "",
        dependentName: "",
        relationship: "",
        dateOfBirth: "",
        dependentGender: "",
        visaType: "",
        contactEmail: "",
        contactNumber: "",
        ssn: "",
        documentType: "",
        documentStatus: "",
        validUntil: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        dependentName: { type: "text", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  return (
    <Modal
      title={"ADD DEPENDENT DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            // noTitle={true}
            options={[
              {
                label: "Is Employee ?",
                value: true,
              },
            ]}
            values={formData.isEmployee || []}
            onChange={(value) => handleChange("isEmployee", value)}
            multiple
            error={errors.isEmployee}
          />
          <FormFieldSet
            type="text"
            title={"Dependent Name"}
            placeholder="Enter Dependent Name"
            value={formData.dependentName}
            onChange={(value) => handleChange("dependentName", value)}
            error={errors.dependentName}
          />
          <FormFieldSet
            type="select"
            title={"Relationship"}
            placeholder="Select Relationship"
            value={formData.relationship}
            onChange={(value) => handleChange("relationship", value)}
            error={errors.relationship}
            options={RelatonShipOptions}
            showSearch
          />
          <FormFieldSet
            type="datepicker"
            title={"Date of Birth"}
            placeholder="Select Date of Birth"
            value={formData.dateOfBirth}
            onChange={(value) => handleChange("dateOfBirth", value)}
            error={errors.dateOfBirth}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Dependent Gender"}
            placeholder="Select Dependent Gender"
            value={formData.priorityDate}
            onChange={(value) => handleChange("priorityDate", value)}
            error={errors.priorityDate}
          />
          <FormFieldSet
            type="select"
            title={"Visa Type"}
            placeholder="Select Visa Type"
            value={formData.visaType}
            onChange={(value) => handleChange("visaType", value)}
            error={errors.visaType}
          />
          <FormFieldSet
            type="text"
            title={"Contact Email"}
            placeholder="Enter Contact Email"
            value={formData.contactEmail}
            onChange={(value) => handleChange("contactEmail", value)}
            error={errors.contactEmail}
          />
          <FormFieldSet
            type="phone"
            title={"Contact Number"}
            placeholder="Enter Contact Number"
            value={formData.contactNumber}
            onChange={(value) => handleChange("contactNumber", value)}
            error={errors.contactNumber}
          />
          <FormFieldSet
            type="text"
            title={"SSN"}
            placeholder="Enter SSN"
            value={formData.ssn}
            onChange={(value) => handleChange("ssn", value)}
            error={errors.ssn}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 mb-4">
              <FormFieldSet
                type="select"
                title={"Document Type"}
                placeholder="Select Document Type"
                value={formData.documentType}
                onChange={(value) => handleChange("documentType", value)}
                error={errors.documentType}
              />
              <FormFieldSet
                type="select"
                title={"Document Status"}
                placeholder="Select Document Status"
                value={formData.documentStatus}
                onChange={(value) => handleChange("documentStatus", value)}
                error={errors.documentStatus}
              />
              <FormFieldSet
                type="datepicker"
                title={"Valid Until"}
                placeholder="Select Valid Until"
                value={formData.validUntil}
                onChange={(value) => handleChange("validUntil", value)}
                error={errors.validUntil}
                showDropdown={false}
              />
            </div>

            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default AddDependent;
